/**
 * 파트너 연동 — 사람이 쓰는 쪽 (261027-partner-link). 파트너 서버 경로는 `../partner.ts` 다.
 *
 *  - 브랜드 설정 — 소유자가 파트너(라이브애드) 계정 이메일을 넣어 연동하고, 해제한다
 *  - 운영자 브랜드 상세 — 연동 상태를 보고 해제한다(남이 먼저 묶었을 때 되돌린다)
 */
import { z } from 'zod';
import { IdParams, IsoDateTime, Ok } from '../common.ts';
import { defineRoute } from '../route.ts';

export const PartnerView = z.object({
  clientName: z.string(),
  /** 살아 있는 연결. 없으면 null — `account` 는 파트너가 돌려준 마스킹 이메일 */
  link: z.object({ account: z.string().nullable(), createdAt: IsoDateTime }).nullable(),
});
export type PartnerView = z.infer<typeof PartnerView>;

// ── 사용자(소유자) ──

export const getMyBrandPartner = defineRoute({
  method: 'get',
  path: '/api/account/brands/{id}/partner',
  access: 'member',
  summary: '파트너 연동 상태(소유자만)',
  params: IdParams,
  response: PartnerView,
});

export const linkMyBrandPartner = defineRoute({
  method: 'post',
  path: '/api/account/brands/{id}/partner/link',
  access: 'member',
  summary:
    '파트너 계정 이메일로 연동(소유자만) — 그 계정이 없으면 404, 다른 브랜드와 연동돼 있으면 409, 이 브랜드가 이미 연동돼 있으면 409',
  params: IdParams,
  body: z.object({ email: z.string().trim().max(254).pipe(z.email()) }).strict(),
  response: PartnerView,
});

export const unlinkMyBrandPartner = defineRoute({
  method: 'delete',
  path: '/api/account/brands/{id}/partner/link',
  access: 'member',
  summary: '연동 해제(소유자만) — 파트너에 바로 알린다. 파트너가 응답하지 않아도 해제는 된다',
  params: IdParams,
  response: Ok,
});

// ── 운영자 ──

export const getAdminBrandPartner = defineRoute({
  method: 'get',
  path: '/api/admin/brands/{id}/partner',
  access: 'admin',
  summary: '파트너 연동 상태',
  params: IdParams,
  response: PartnerView,
});

export const unlinkAdminBrandPartner = defineRoute({
  method: 'delete',
  path: '/api/admin/brands/{id}/partner/link',
  access: 'admin',
  summary: '연동 해제 — 남이 먼저 묶었을 때 되돌리는 길이다',
  params: IdParams,
  response: Ok,
});
